export default __webpack_public_path__ + "static/27729-467d1095e14867d0360e84a0b80a648a.jpg";